import React from 'react';
import type { HeaderProps } from '@goodfynd/react-web.layout.header';
import { Header as FyndHeader } from '@goodfynd/react-web.layout.header';
import { observer } from 'mobx-react-lite';

import config from '../../../config';
import { useApp, useAppDispatch } from '../../../context/AppContext';
import { useStores } from '../../../stores';

import { MAIN_NAV } from './header-links';

export default observer(function Header(props: Partial<HeaderProps>) {
  const { eventId, unsetEvent } = useStores();
  const { user, isLoggedIn } = useApp();
  const { getLoginUrl, logout } = useAppDispatch();
  const navLinks = props.navLinks || MAIN_NAV(user, eventId, isLoggedIn);

  return (
    <FyndHeader
      {...props}
      authenticated_navigation={[]}
      getLoginUrl={getLoginUrl}
      isAuthenticated={isLoggedIn}
      logoEnvironment={config.env.NAME_LOWER}
      logoType="events"
      navLinks={navLinks}
      theme="white"
      unauthenticated_navigation={[]}
      userFullName={user.fullName}
      userInitials={user.initials?.replace(' ', '')}
      logout={() => {
        unsetEvent();
        logout();
      }}
    />
  );
});
